import { useMemo } from 'react'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'
import { ESearchFilterValue } from '@cbgms/components/src/top-search/topSearchUtils'
import { usePersistedState } from '@cbgms/base/hooks/persisted-state/use-persisted-state'

const defaultFilterValue = (isPortal: boolean) => {
  return isPortal ? ESearchFilterValue.AllPortal : ESearchFilterValue.AllGMS
}

export const useSearchCategoryFilter = () => {
  const isPortal = useIsPortal()
  const [_searchFilter, setSearchFilter] = usePersistedState('main-search-filter-new', defaultFilterValue(isPortal))

  // Force the searchFilter to 'all', portal isn't showing a filter anymore
  const searchFilter = !isPortal ? _searchFilter : ESearchFilterValue.AllPortal
  const showSearchFilter = !isPortal

  return useMemo(
    () => ({
      showSearchFilter,
      searchFilter,
      setSearchFilter
    }),
    [showSearchFilter, searchFilter, setSearchFilter]
  )
}
